@if (config.options) {
  @if (config.options.length === 1 && config.ifOneOptionShowStaticText) {
    <p
      [ngStyle]="{ 'text-align': config.alignStaticText }"
      class="dropdown__static-text"
      [ngStyle]="{ 'text-align': config.alignStaticText }"
      tabindex="0"
    >
      {{ config.options[0].label }}
    </p>
  } @else {
    @if (!config.hideIfOnlyOneOption || hideOrShowOptions()) {
      <div
        class="form-control form-control--dropdown"
        [ngClass]="{ 'form-control--readonly': config.readonly }"
        [attr.disabled]="isDisabled || null"
        [attr.readonly]="config.readonly || null"
      >
        <select
          ngDefaultControl
          [attr.disabled]="isDisabled || null"
          [attr.readonly]="config.readonly || null"
          [formControl]="dropdownDisplayControl"
          [id]="config.id || config.prop"
          [attr.aria-label]="config?.prop + '-input'"
          [attr.aria-describedby]="(config?.id || config?.prop) + '-label'"
          [attr.aria-errormessage]="
            'error_' + (config?.id || config?.prop) + '-input'
          "
          [attr.aria-invalid]="
            (dropdownDisplayControl.dirty || dropdownDisplayControl.touched) &&
            !dropdownDisplayControl.valid
          "
          name="dropdownDisplayControl"
          [attr.data-test-id]="'Dropdown_' + (config.id || config.prop)"
          [attr.autocomplete]="config?.autocomplete || config.prop"
          (change)="onOptionSelected($event, config)"
        >
          @for (option of config.options; track option; let i = $index) {
            <option
              tabindex="0"
              [ngValue]="option.value"
              [attr.disabled]="
                option.isDisabled ||
                (option.value === null &&
                  config.validators?.includes('required'))
                  ? true
                  : null
              "
              [attr.selected]="i === selectedIndex ? 'selected' : null"
              [innerHTML]="option.label"
            ></option>
          }
        </select>
        <input type="hidden" [formControl]="control" [name]="control.prop" />
        <div class="u-flex u-alignCenter u-justifyEnd u-fillRemaining">
          <icon
            [config]="{
              format: 'svg',
              size: config.iconSize || 'small',
            }"
            [name]="config.icon || 'carat_down'"
            class="dropdown__chevron"
          ></icon>
        </div>
      </div>
    }
  }
}
